import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const triggerCompetitorDiscovery = unaryRpc({
  name: "triggerCompetitorDiscovery",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
});
